import { useState } from 'react'
import AxiosAgent from '../../api/Agent'

const useAgent = <T>() => {
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')
    const agent = {
        Assemblies: {
            list: async (selectedDateRange: number, criteria: string) => {
                try {
                    setLoading(true)
                    const params = {
                        dateRange: selectedDateRange,
                        criteria,
                    }
                    const response = await AxiosAgent.Requests.post<T[]>(
                        'order/search/assembly',
                        params
                    )

                    if (response.length === 0) {
                        setLoading(false)
                        setMessage('No data available')
                        return response
                    }
                    setLoading(false)
                    return response
                } catch (error) {
                    setLoading(false)
                    setMessage(error as string)
                    // Handle error here
                    //TODO Log error
                }
            },
            loading: loading,
            message: message,
        },
    }
    return { agent }
}

export default useAgent
